import { Navigate, useLocation } from "react-router-dom";

import { FlowPageParams, getFlowSubpageUrl } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const LegacyAnalyticsPathRedirect: React.FC = () => {
  const { orgId, wsId, flow_id: flowId } = useParamsDecode<FlowPageParams>();
  const { search } = useLocation();

  const pathname = getFlowSubpageUrl(orgId, wsId, flowId, "insights", {
    keepFlags: false,
  });

  return <Navigate replace to={{ pathname, search }} />;
};
